import React, { useEffect } from 'react';
import './TextArea.less';
import { useReframe } from 'nike-re-framejs';
import clsx from 'clsx';
import { makeField, NfTextarea } from 'nike-form-js';
import FieldErrors from './FieldErrors';
import Immutable from 'immutable';

const TextArea = React.forwardRef(
    (
        {
            form,
            path,
            label,
            size,
            hint,
            type,
            optional,
            disabled = false,
            className,
            children,
            dataAtid,
            rows = 4,
            value,
            hasError,
            errorText,
            ...rest
        },
        ref
    ) => {
        const { deref } = useReframe();
        const field = form && makeField(form, path);
        const errors = form && deref(field.getErrors());
        const isTouched = form && deref(field.isTouched());
        const isError = form ? isTouched && errors.size > 0 : hasError;
        const id = '' + path;

        const textAreaMaxHeight = 10 + 20 * 10;

        useEffect(() => {
            if (ref && ref.current) {
                ref.current.style.height = 'auto';
                ref.current.style.height = Math.min(ref.current.scrollHeight + 2, textAreaMaxHeight) + 'px';
            }
        }, [ref, textAreaMaxHeight]);

        return (
            <label
                className={clsx([
                    'nui-input p-rel mb-20 flex flex-col textarea-bottom',
                    disabled ? 'nui-input-disabled' : null,
                    className
                ])}
            >
                {label ? (
                    <div
                        className={clsx('nui-input-label fs-14 text-extra-bold inline-box', {
                            'nui-input-label fs-14 text-extra-bold': !optional
                        })}
                    >
                        {label}
                        {optional ? <div className="optional-label inline-box">{optional}</div> : null}
                    </div>
                ) : null}
                {hint ? <div className="nui-input-hint fs-12">{hint}</div> : null}
                {form ? (
                    <NfTextarea
                        field={field}
                        attrs={Object.assign({}, rest, {
                            id,
                            ref,
                            type,
                            disabled,
                            rows: rows,
                            className: clsx('nui-native-input', size, { 'nui-input-error': isError }),
                            'data-atid': dataAtid
                        })}
                    />
                ) : (
                    <textarea
                        ref={ref}
                        disabled={disabled}
                        value={value}
                        rows={rows}
                        className={clsx(
                            'nui-native-input',
                            size,
                            { 'nui-input-error': isError },
                            { 'data-atid': dataAtid }
                        )}
                        {...rest}
                    />
                )}
                {children}
                {isError ? <FieldErrors errors={errors || Immutable.List([errorText])} /> : null}
            </label>
        );
    }
);

export default TextArea;
